import root from 'window-or-global';
import {PayoutAccountStatus, PaymentStatus, BOAPaymentAccountStatus} from '../../shared/types';

export function isPendingWalletStatus(status: string): boolean {
    if (!status) {
        return false;
    }
    return (
        status === PayoutAccountStatus.ACCOUNT_PENDING_VERIFICATION ||
        status === PayoutAccountStatus.ACCOUNT_PENDING_ACTIVATION
    );
}

export function displayBOAButton(accountStatus: BOAPaymentAccountStatus): boolean {
    return (
        accountStatus !== BOAPaymentAccountStatus.BOA_ACCOUNT_DISABLED &&
        accountStatus !== BOAPaymentAccountStatus.BOA_ACCOUNT_LOCKED &&
        accountStatus !== BOAPaymentAccountStatus.BOA_ACCOUNT_NOT_EXIST
    );
}

export function transformAmount(amount = 0) {
    return `$${(amount / 100.0).toFixed(2)}`;
}

export function getPaymentStatusCode(status) {
    let code = 'epic.affiliate.form.payout.status.unknown.v2';
    switch (status) {
        case PaymentStatus.FAILED:
            code = 'epic.affiliate.form.payout.status.failed.v2';
            break;
        case PaymentStatus.COMPLETED:
            code = 'epic.affiliate.form.payout.status.complete.v2';
            break;
        case PaymentStatus.IN_PROGRESS:
            code = 'epic.affiliate.form.payout.status.ip.v2';
            break;
        default:
            break;
    }
    return code;
}

export enum UserActionEventType {
    CREATE_TAX_PROFILE = 'createTaxProfile',
    CONSENT = 'isConsent',
    OFFLINE = 'isOffline'
}

const setUserActionEvent = (eventName: UserActionEventType) => {
    return root.document.dispatchEvent(
        /*global CustomEvent*/
        new CustomEvent('NEED_ACTIONS', {
            bubbles: true,
            detail: {
                eventName
            }
        })
    );
};

const initEvent = (history, link: string, type: UserActionEventType) => {
    if (!history || !type || !link) return;
    const {location} = history || {};
    const {pathname = ''} = location || {};
    if (pathname.includes('settings')) {
        setUserActionEvent(type);
    } else {
        history.push(link);
    }
};

export const initCreateTaxProfile = history =>
    initEvent(history, 'settings?createTaxProfile=true', UserActionEventType.CREATE_TAX_PROFILE);

export const initConsent = history =>
    initEvent(history, 'settings?isConsent=true', UserActionEventType.CONSENT);

export const initOfflineType = history =>
    initEvent(history, 'settings?isOffline=true', UserActionEventType.OFFLINE);
